import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { WorkspaceProvider, useWorkspace } from './context/WorkspaceContext';
import { OnboardingPage } from './pages/Onboarding';
import { DashboardPage } from './pages/Dashboard';
import { TasksPage } from './pages/Tasks';
import { CRMPage } from './pages/CRM';
import { NotesPage } from './pages/Notes';
import { InsightsPage } from './pages/Insights';
import { AssistantPage } from './pages/Assistant';
import { TeamPage } from './pages/Team';
import { BuildReviewPage } from './pages/BuildReview';
import { LandingPageCanvas } from './pages/LandingPageCanvas';
import { SidebarCustomizer } from './pages/SidebarCustomizer';

function AppShell() {
  const { currentWorkspace } = useWorkspace();

  if (!currentWorkspace) {
    return <OnboardingPage />;
  }

  return (
    <Routes>
      <Route path="/canvas" element={<LandingPageCanvas />} />
      <Route path="*" element={
        <Layout>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/crm" element={<CRMPage />} />
            <Route path="/notes" element={<NotesPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/build-review" element={<BuildReviewPage />} />
            <Route path="/assistant" element={<AssistantPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/settings" element={<SidebarCustomizer />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Layout>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <WorkspaceProvider>
        <AppShell />
      </WorkspaceProvider>
    </BrowserRouter>
  );
}
